import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getTOAll(params) {
	return client.get("api/to/all", {
		params: params,
	});
}
function getTOIn(params) {
	return client.get("api/to/data-in", {
		params: params,
	});
}

function getTOOut(params) {
	return client.get("api/to/data-out", {
		params: params,
	});
}

function exportTO(params) {
	return client.get("api/to/export", {
		params: params,
	});
}

function exportTOAll(params) {
	return client.get("api/to/export-all", {
		params: params,
	});
}

function exportTOIN(params) {
	return client.get("api/to/export-in", {
		params: params,
	});
}

function exportTOOUT(params) {
	return client.get("api/to/export-out", {
		params: params,
	});
}

function detailTO(params) {
	return client.get("api/to/detail", {
		params: {
			to_code : params
		},
	});
}

function getTOStatus() {
	return client.get("api/options/to-status");
}

function createTO (params) {
	return client.post("api/to/create", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function createTORetur (params) {
	return client.post("api/to/create-retur", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function approveTO (params) {
	return client.post("api/to/approve", qs.stringify({
		to_id: params
	}), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function rejectTO (params) {
	return client.post("api/to/reject", qs.stringify({
		to_id: params
	}), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteTO (params) {
	return client.post("api/to/delete", qs.stringify({
		to_id: params
	}), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function approvalAdminTO (params) {
    return client.post("api/to/approval-admin", qs.stringify(params), {
      header: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  }

export default {
	getTOAll,
	exportTO,
	exportTOAll,
	exportTOIN,
	exportTOOUT,
	detailTO,
	getTOStatus,
	createTO,
	createTORetur,
	approveTO,
	rejectTO,
	deleteTO,
	getTOIn,
	getTOOut,
	approvalAdminTO,
};

